module.exports = __webpack_public_path__ + "img/index-banner2.8e48634f.png";